import createEscaper from './_createEscaper.js';
import escapeMap from './_escapeMap.js';

// Function for escaping strings to HTML interpolation.
export default createEscaper(escapeMap);



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/escape.js
// module id = 177
// module chunks = 0